import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es6.function.name';
import 'core-js/modules/es6.regexp.to-string';
import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js';
import _createClass from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js';
import _assertThisInitialized from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized.js';
import _get from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/get.js';
import _inherits from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js';
import _possibleConstructorReturn from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js';
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== 'undefined' && o[Symbol.iterator] || o['@@iterator'];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
            if (it)
                o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length)
                        return { done: true };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null)
                    it.return();
            } finally {
                if (didErr)
                    throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/toolbar/toolbarview
 */
/* globals console */
import View from '../view';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import FocusCycler from '../focuscycler';
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import ToolbarSeparatorView from './toolbarseparatorview';
import preventDefault from '../bindings/preventdefault.js';
import '../../theme/components/toolbar/toolbar.css';
import { attachLinkToDocumentation } from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * The toolbar view class.
 *
 * @extends module:ui/view~View
 * @implements module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable
 */
var ToolbarView = /*#__PURE__*/
function (_View) {
    _inherits(ToolbarView, _View);
    var _super = _createSuper(ToolbarView);
    /**
   * Creates an instance of the {@link module:ui/toolbar/toolbarview~ToolbarView} class.
   *
   * Also see {@link #render}.
   *
   * @param {module:utils/locale~Locale} locale The localization services instance.
   */
    function ToolbarView(locale) {
        var _this;
        _classCallCheck(this, ToolbarView);
        _this = _super.call(this, locale);
        var bind = _this.bindTemplate;
        var t = _this.t;
        /**
     * Label used by assistive technologies to describe this toolbar element.
     *
     * @default 'Editor toolbar'
     * @member {String} #ariaLabel
     */
        _this.set('ariaLabel', t('Editor toolbar'));
        /**
     * Collection of the toolbar items (like buttons).
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this.items = _this.createCollection();
        /**
     * Tracks information about DOM focus in the list.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */
        _this.focusTracker = new FocusTracker();
        /**
     * Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */
        _this.keystrokes = new KeystrokeHandler();
        /**
     * Controls the orientation of toolbar items.
     *
     * @observable
     * @member {Boolean} #isVertical
     */
        _this.set('isVertical', false);
        /**
     * An additional CSS class added to the {@link #element}.
     *
     * @observable
     * @member {String} #class
     */
        _this.set('class');
        /**
     * Helps cycling over focusable {@link #items} in the toolbar.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */
        _this._focusCycler = new FocusCycler({
            focusables: _this.items,
            focusTracker: _this.focusTracker,
            keystrokeHandler: _this.keystrokes,
            actions: {
                // Navigate toolbar items backwards using the arrow[left,up] keys.
                focusPrevious: [
                    'arrowleft',
                    'arrowup'
                ],
                // Navigate toolbar items forwards using the arrow[right,down] keys.
                focusNext: [
                    'arrowright',
                    'arrowdown'
                ]
            }
        });
        _this.setTemplate({
            tag: 'div',
            attributes: {
                class: [
                    'ck',
                    'ck-toolbar',
                    bind.if('isVertical', 'ck-toolbar_vertical'),
                    bind.to('class')
                ],
                role: 'toolbar',
                'aria-label': bind.to('ariaLabel')
            },
            children: _this.items,
            on: {
                // https://github.com/ckeditor/ckeditor5-ui/issues/206
                mousedown: preventDefault(_assertThisInitialized(_this))
            }
        });
        return _this;
    }
    /**
   * @inheritDoc
   */
    _createClass(ToolbarView, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                _get(_getPrototypeOf(ToolbarView.prototype), 'render', this).call(this);
                // Items added before rendering should be known to the #focusTracker.
                var _iterator = _createForOfIteratorHelper(this.items), _step;
                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var item = _step.value;
                        this.focusTracker.add(item.element);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
                this.items.on('add', function (evt, item) {
                    _this2.focusTracker.add(item.element);
                });
                this.items.on('remove', function (evt, item) {
                    _this2.focusTracker.remove(item.element);
                });
                // Start listening for the keystrokes coming from #element.
                this.keystrokes.listenTo(this.element);
            }    /**
     * Focuses the first focusable in {@link #items}.
     */
        },
        {
            key: 'focus',
            value: function focus() {
                this._focusCycler.focusFirst();
            }    /**
     * Focuses the last focusable in {@link #items}.
     */
        },
        {
            key: 'focusLast',
            value: function focusLast() {
                this._focusCycler.focusLast();
            }    /**
     * A utility which expands a plain toolbar configuration into
     * {@link module:ui/toolbar/toolbarview~ToolbarView#items} using a given component factory.
     *
     * @param {Array.<String>} config The toolbar items config.
     * @param {module:ui/componentfactory~ComponentFactory} factory A factory producing toolbar items.
     */
        },
        {
            key: 'fillFromConfig',
            value: function fillFromConfig(config, factory) {
                var _this3 = this;
                config.map(function (name) {
                    if (name == '|') {
                        _this3.items.add(new ToolbarSeparatorView());
                    } else if (factory.has(name)) {
                        _this3.items.add(factory.create(name));
                    } else {
                        /**
           * There was a problem processing the configuration of the toolbar. The item with the given
           * name does not exist so it was omitted when rendering the toolbar.
           *
           * This warning usually shows up when the {@link module:core/plugin~Plugin} which is supposed
           * to provide a toolbar item has not been loaded or there is a typo in the configuration.
           *
           * Make sure the plugin responsible for this toolbar item is loaded and the toolbar configuration
           * is correct, e.g. {@link module:basic-styles/bold~Bold} is loaded for the `'bold'` toolbar item.
           *
           * You can use the following snippet to retrieve all available toolbar items:
           *
           *		Array.from( editor.ui.componentFactory.names() );
           *
           * @error toolbarview-item-unavailable
           * @param {String} name The name of the component.
           */
                        console.warn(attachLinkToDocumentation('toolbarview-item-unavailable: The requested toolbar item is unavailable.'), { name: name });
                    }
                });
            }
        }
    ]);
    return ToolbarView;
}(View);
export {
    ToolbarView as default
};